import { Form, Switch } from 'antd-v5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SettingsContent } from '../../../components/SettingsContent';
import DescriptionBox from '../../../../../../components/Layout/DescriptionBox';

export const ProductSettingsSection = ({ form }) => {
  return (
    <SettingsContent title="HIDE PRODUCT COST" icon={<FontAwesomeIcon icon={['fas', 'dollar-sign']} />} className="w-100-P">
      <DescriptionBox
        className="w-100-P"
        description="When this setting is turned off, admins and managers will be able to see the product cost when selecting a product. When turned on, cost will be hidden on the product page."
        input={
          <Form.Item name="hideProductCost" valuePropName="checked">
            <Switch />
          </Form.Item>
        }
      />
    </SettingsContent>
  );
};
